// Production - nginx proxies /api to backend
export const API_URL = "/api";
export const APPLICATION_DATE_FORMAT = "DD-MMM-YYYY";
export const COMMON_PLAYER_PASSWORD = "Bjit@123#";
